import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SmartTableComponent } from './smart-table';
import { StRatioModule } from './st-ratio/st-ratio.module';
import { StSelectRowCustomModule } from './st-select-row-custom/st-select-row-custom.module';
import { StTableModule } from './st-table/st-table.module';
import { StSearchModule } from './st-search/st-search.module';
import { StSelectRowModule } from './st-select-row/st-select-row.module';
import { StSortModule } from './st-sort/st-sort.module';
import { StPaginationModule } from './st-pagination/st-pagination.module';
import { StPipeModule } from './st-pipe/st-pipe.module';
import { StPaginationScrollModule } from './st-pagination-scroll/st-pagination-scroll.module';
import './smart-table.scss';

export const SmartTableModule: string = ng
    .module('smart-table', [
        'ui.bootstrap',
        uiRouter,
        StSelectRowCustomModule,
        StRatioModule,
        StTableModule,
        StSearchModule,
        StSelectRowModule,
        StSortModule,
        StPaginationModule,
        StPipeModule,
        StPaginationScrollModule
    ])
    .component('smartTable', SmartTableComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/smart-table.module.ts